jQuery(document).ready(function($) {
    $('.evblocks-gallery__slider').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true,
        arrows: true,
    prevArrow: '<button type="button" class="slick-prev custom-arrow">&#x25C0;</button>', // ◀
    nextArrow: '<button type="button" class="slick-next custom-arrow">&#x25B6;</button>', // ▶
    });
});
